import React, { useState, useEffect } from "react";
import ArcReactor from "./Arc";
import Visualizer from "./Visualizer";
import "./App.css";

const App = () => {
  const [isSpeaking, setIsSpeaking] = useState(false);

  // Simulating toggling `isSpeaking` state (replace with actual logic)
  useEffect(() => {
    const interval = setInterval(() => {
      setIsSpeaking((prev) => !prev);
    }, 3000); // Toggles every 3 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="appContainer">
      <ArcReactor />
      <Visualizer isSpeaking={isSpeaking} />
    </div>
  );
};

export default App;
